#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment programmePreview on programme_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    shortDescription
}
